import { MainContentLayout } from 'shared/ui/layout';

import { EditCountry } from 'features/country/edit';

export function EditCountryPage() {
  return <MainContentLayout element={<EditCountry />} />;
}
